class Referral {
	constructor(referralForms, shareLinks) {
		this.referralForms = referralForms ;
		this.shareLinks = shareLinks;
	}
	revealForm(customer, newUserElementClass, existingUserElementClass) {
 		if (customer.email === undefined) {
 			 $(`.${newUserElementClass}`).addClass("showing-form");
 			 $(".swell-referral-mail p").text("ENTER EMAIL *");

 		} else {
 			$(`.${existingUserElementClass}`).addClass("showing-form");
 			$(".swell-referral-mail p").append(
 				$("<p>").text("Now, enter your friends' emails.").addClass("swell-referral-mail-p"),
 			   $("<p>").text("NOW ENTER YOUR FRIENDS’ EMAILS*.").addClass("swell-referral-mail-p-mob"));
 		} 
	}
	renderReferralForm(form , onSubmit) {
		$(".swell-referral-mail").append(
			$("<form>").addClass(form.formType).append(
				$("<label>").append(
					$("<input>", {
						type: form.inputType,
						placeholder: form.placeholder
					}),
					$("<input>", {
						type: "submit",
						value: form.submitText
					})
		    )
		).addClass("hidden-form").submit((e) => onSubmit(e))
		)
	
	 form.formType === "existing" ?  this.renderShareLinks(form.formType)  : "";
    }
	showReferralForm() {
		this.renderReferralForm(this.referralForms.newUserForm , this.onClientEmailSubmit);
		this.renderReferralForm(this.referralForms.existingUserForm , this.onFriendEmailSubmit);
    }
    renderShareLinks(formClass) {
		$(`.${formClass}`).append(
			$("<div>").addClass("swell-share-container").append(
			$("<div>").addClass("swell-share-links-container")))
		this.shareLinks.forEach((shareLink, index) => {
			$(".swell-share-links-container").append(
				$("<div>").append(
					$("<i>").addClass(shareLink.text),
					// $("<img>", {
					// 	src: shareLink.icon
					// }),
					$("<a>", {
						href: shareLink.href,
						text: shareLink.text,
					}).addClass("swell-share-link").addClass(shareLink.class),
				).addClass("swell-share-link-div"),	
			)
			if (shareLink.text === "SMS") {
				$(`.swell-share-link-div:nth-of-type(${index+1})`).addClass("swell-share-link-sms")
			}
		})
		
		$(".swell-share-links-container").append(
			$("<div>").append(
				$("<i>").addClass("copylink"),
				$("<a>", {
						href: "javascript:void(0)",
						text: "Copy Link" ,
					}).addClass("swell-share-link").addClass("swell-share-referral-copy-link").click(this.copyLinkClick)
			).addClass("swell-share-link-div"),
		)
		//$(".swell-referral-history-link").click(this.showReferralHistory);		
	}
	copyLinkClick() {
		// //click(() => {
		// 		navigator.clipboard.writeText(swellAPI.getCustomerDetails().referralLink)
		// 			//$(".swell-link-code").removeAttr("disabled").select().attr({disabled: "disabled"});
				
 	// 			//}),

	$(".swell-referral-container").append(
		$("<div>").addClass("swell-popup-background").append(
			$("<div>").addClass("swell-popup-body").append(
				$("<div>").addClass("swell-popup-text").append(
					$("<img>").addClass("swell-popup-close").click(() => {
						$(".swell-popup-background").remove();
					}),
					$("<input>", {
						type: "text",
						value: swellAPI.getCustomerDetails().referralLink,
						disabled: "disabled"
					}).addClass("swell-link-code"),

					$("<div>").text("COPY MY LINK").addClass("swell-copy-link-btn")
					.click(() => {
					navigator.clipboard.writeText(swellAPI.getCustomerDetails().referralLink),
					$(".swell-link-code").removeAttr("disabled").select().attr({disabled: "disabled"});
				
					}),
					$("<p>").text("Copy link and share with your friends."),)
			)
		)
	)
	}
	onClientEmailSubmit(e) {
	e.preventDefault();
	let customerInput = $("form.new input");

	let onSuccess = function() {
		$(".swell-form-error").remove();
		$("form.new").removeClass("showing-form").addClass("hidden-form");
		$("form.existing").removeClass("hidden-form").addClass("showing-form");
		$(".swell-referral-mail p").text("Now, enter your friends' emails.");
		
		
	}

	let onError = function() {
		$(".swell-form-error").remove();
		$("form.new label").append(
		    	$("<p>").text("Please check your email and try again.").addClass("swell-form-error")
		)
	}
	swellAPI.identifyReferrer(customerInput.val(), onSuccess, onError);	
	}
	onFriendEmailSubmit(e) {
	e.preventDefault();
	let referredCustomersInput = $("form.existing input");
	let emails = referredCustomersInput.val().split(",");
	let onSuccess = function() {
		$(".swell-form-error").remove();
		$("form.existing").append(
			$("<div>").addClass("swell-popup-background").append(
			$("<div>").addClass("swell-popup-body").append(
			$("<img>").addClass("swell-popup-img"),
			$("<div>").addClass("swell-popup-text").append(
				$("<div>").text("x").addClass("swell-popup-close").click(() =>{ $(".swell-popup-background").remove()}),
			$("<h2>").text("Thanks!"),
			$("<p>").text("The email was submitted!"),
					
		    ))).addClass("swell-thanks")
	    );
      console.log('user ' + swellAPI.getCustomerDetails().email + ' successfully referred '+ emails);
       $(".swell-referral-mail form input[type=text]").val('');
        $(".swell-ref-history-rewards-balance").empty();
        $(".swell-referral-history").empty();
            swellAPI.refreshCustomerDetails();
            
            setTimeout(() => {
                new ReferralHistory(swellAPI.getCustomerDetails()).renderReferralHistory();
                
            }, 1000)
	}
	let onError = function() {
		$(".swell-form-error").remove();
		$("form.existing label").append(
		    	$("<p>").text("Please check the email and try again.").addClass("swell-form-error")
		)
        console.log(swellAPI.getCustomerDetails().email + ' is getting an error from trying to refer '+ emails);
	}
	swellAPI.sendReferralEmails(emails, onSuccess, onError);
	}
	
}